import React, { useState } from "react";
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from '@mui/icons-material/Send';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import { CreateTableNew as CreateTable } from "../../../../../common/APICommon";

const MedicalClearanceTable = ({ data, onAction, onEdit, onDelete, onRelease, userAccess }) => {
  const [currentPage, setCurrentPage] = useState(1);

  const headers = ["Trans #", "Full Name", "Vessel", "Status", "Actions"];
  const accessors = ["transactionNumber", "employeeFullName", "vesselName", "status", "actions"];

  const actions = [
    {
      tooltip: "Release to Clinic",
      icon: <SendIcon fontSize="small" />,
      color: "bg-orange-500",
      visible: (row) => row.status === "Draft" && userAccess?.isMedicalClearanceManager,
      function: (row) => onRelease(row),
    },
    {
      tooltip: "Edit Draft",
      icon: <EditIcon fontSize="small" />,
      color: "bg-green-600",
      visible: (row) => row.status === "Draft" && userAccess?.isMedicalClearanceManager,
      function: (row) => onEdit(row),
    },
    {
      tooltip: "Delete Draft",
      icon: <DeleteIcon fontSize="small" />,
      color: "bg-red-600",
      visible: (row) => row.status === "Draft" && userAccess?.isMedicalClearanceManager,
      function: (row) => onDelete(row),
    },
    {
      tooltip: "Process Requirements",
      icon: <SettingsSuggestIcon fontSize="small" />,
      color: "bg-blue-600",
      visible: (row) => row.status === "Processing" && userAccess?.isMedicalClearanceProcessor,
      function: (row) => onAction(row),
    },
    {
      tooltip: "View Details",
      icon: <VisibilityIcon fontSize="small" />,
      color: "bg-gray-500",
      visible: (row) => row.status === "Completed" || (row.status === "Processing" && !userAccess?.isMedicalClearanceProcessor),
      function: (row) => onAction(row),
    }
  ];

  const customCellRenderer = (row, accessor) => {
    if (accessor === "status") {
      const s = row[accessor];
      const config = {
        "Draft": "bg-gray-100 text-gray-700 border-gray-300",
        "Processing": "bg-orange-50 text-orange-700 border-orange-200",
        "Completed": "bg-green-50 text-green-700 border-green-200"
      };
      return (
        <div className={`flex items-center gap-1 px-2 py-1 rounded-full text-[10px] font-bold w-fit border ${config[s]}`}>
          {s === "Completed" ? <CheckCircleIcon sx={{ fontSize: 12 }} /> : <HourglassEmptyIcon sx={{ fontSize: 12 }} />}
          {s.toUpperCase()}
        </div>
      );
    }
    return null;
  };

  return (
    <CreateTable
      tableName="MedicalClearanceTable"
      headers={headers}
      accessors={accessors}
      data={data}
      actions={actions}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      itemsPerPage={10}
      totalItems={data?.length || 0}
      customCellRenderer={customCellRenderer}
    />
  );
};

export default MedicalClearanceTable;